import axios from "axios";

const API = axios.create({
  baseURL: "https://app-backend-ka51.onrender.com/api/v1",
});
// const API = axios.create({ baseURL: "http://localhost:5000/api/v1" });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("profile")).token
    }`;
  }

  return req;
});

export const signIn = (formData) => API.post("/users/login", formData);
export const signUp = (formData) => API.post("/users/register", formData);
export const createStore = (FormData) => API.post(`/store`, FormData);

export const getProducts = (storeId) => API.get(`/products/all/${storeId}`);
export const getProduct = (id) => API.get(`/products/${id}`);
export const createProduct = (formData) => API.post("/products", formData);
export const updateProduct = (id, formData) =>
  API.patch(`/products/${id}`, formData);
export const updateProductGallery = (id, formData) =>
  API.patch(`/products/gallery/${id}`, formData);
export const deleteProduct = (id) => API.delete(`/products/${id}`);
export const deleteImage = (id, imageName) =>
  API.delete(`/products/product/${id}/gallery/${imageName}`);

export const createCategory = (FormData) => API.post(`/categories`, FormData);
export const getCategories = (storeId) => API.get(`/categories/all/${storeId}`);
export const getCategory = (id) => API.get(`/categories/${id}`);
export const updateCategory = (id, FormData) =>
  API.put(`/categories/${id}`, FormData);
export const deleteCategory = (id) => API.delete(`/categories/${id}`);

export const createOrder = (FormData) => API.post(`/orders`, FormData);
export const getTotalIncome = (storeId) =>
  API.get(`/orders/totalsales/${storeId}`);
export const getOrders = (storeId) => API.get(`/orders/all/${storeId}`);
export const getOrder = (id) => API.get(`/orders/${id}`);
export const updateOrder = (id, formData) => API.put(`/orders/${id}`, formData);
export const deleteOrder = (id) => API.delete(`/orders/${id}`);

export const createUser = (FormData) => API.post(`/users`, FormData);
export const getUsers = (storeId, role) =>
  API.get(`/users/all/${storeId}/${role}`);
export const getUser = (id) => API.get(`/users/${id}`);
export const updateUser = (id, formData) => API.put(`/users/${id}`, formData);
export const deleteUser = (id) => API.delete(`/users/${id}`);

export const getStore = (storeId) => API.get(`/store/${storeId}`);
export const getStores = () => API.get(`/store`);
export const updateStore = (id, formData) => API.put(`/store/${id}`, formData);

export const createStoreInfo = (formData) => API.post("/storeinfo", formData);
export const updateStoreInfo = (id, formData) =>
  API.put(`/storeinfo/${id}`, formData);

export const createShipping = (FormData) => API.post(`/shipping`, FormData);
// export const getShippings = (storeId) => API.get(`/shipping/all/${storeId}`);
export const getShipping = (id) => API.get(`/shipping/${id}`);
export const deleteShipping = (id) => API.delete(`/shipping/${id}`);
export const updateShipping = (id, formData) =>
  API.put(`/shipping/${id}`, formData);
